import {
  LegalPersonalityEnum,
  LegalPersonalityIdEnum,
} from 'src/app/domain/enums/legal-personality.enum';
import { ContributorTypeIdEnum } from 'src/app/domain/registration/enums/contributor-type.enum';
import { FiscalEnvironmentIdEnum } from 'src/app/domain/registration/enums/fiscal-environment.enum';
import { RegimeTypeIdEnum } from 'src/app/domain/registration/enums/regime-type.enum';
import { GlobalUtils } from 'src/app/shared/global-utils';

export class FormDataUpdate {
  public async build(element: any): Promise<FormData> {
    let {
      id,
      image,
      code,
      legalPersonality,
      name,
      birthday,
      cnpj,
      cpf,
      companyName,
      tradingName,
      generalRegistration,
      stateRegistration,
      municipalRegistration,
      contributorType,
      phone,
      cellPhone,
      email,
      webSite,
      cep,
      address,
      addressComplement,
      addressNumber,
      neighborhood,
      state,
      city,
      addressObservation,
      externalCode,
      country,
      mainActivity,
      contract,
      contractDate,
      signedAt,
      license,
      licenseDate,
      lastBackup,
      lastBackupDate,
      customerPlans,
      additionalBranches,
      accessQuantity,
      consultant,
      consultantCommission,
      partner,
      partnerCommission,
      representative,
      representativeCommission,
      counter,
      counterCommission,
      unit,
      unitCommission,
      regime,
      fiscalEnvironment,
      csc,
      cscId,
      digitalCertificate,
      digitalCertificateDate,
      isActive,
      createdAt,
      updatedAt,
      contractComment,
      licenseComment,
      lastBackupComment,
      digitalCertificateComment
    } = element;

    let formData = new FormData();

    formData.append('id', id);

    if (image?.toLowerCase().indexOf(';base64') != -1)
      formData.append(
        'image',
        new File(
          [await GlobalUtils.blobImageFromBase64String(image)],
          image?.toLowerCase().indexOf('png') != -1
            ? `filename.png`
            : `filename.jpeg`
        )
      );
    else formData.append('image', image);

    formData.append('legalPersonality', legalPersonality);
    formData.append('code', code);

    if (
      legalPersonality ===

      LegalPersonalityIdEnum[LegalPersonalityEnum.PESSOA_FISICA]
    ) {
      formData.append('cpf', cpf);
      formData.append('name', name?.toUpperCase());
      formData.append('generalRegistration', generalRegistration);
    } else {
      formData.append('cnpj', cnpj);
      formData.append('companyName', companyName?.toUpperCase());
      formData.append('stateRegistration', stateRegistration);
      formData.append('municipalRegistration', municipalRegistration);
    }

    const formattedBirthday = birthday ? new Date(birthday).toISOString().split('T')[0] : '';
    formData.append('birthday', formattedBirthday);

    formData.append('isActive', isActive);
    formData.append('tradingName', tradingName?.toUpperCase());
    formData.append('contributorType', ContributorTypeIdEnum[contributorType]);
    formData.append('phone', phone);
    formData.append('cellPhone', cellPhone);
    formData.append('email', email);
    formData.append('webSite', webSite);

    formData.append('cep', cep);
    formData.append('address', address);
    formData.append('addressComplement', addressComplement);
    formData.append('addressNumber', addressNumber);
    formData.append('neighborhood', neighborhood);
    formData.append('state', state);
    formData.append('city', city);
    formData.append('addressObservation', addressObservation);
    formData.append('externalCode', externalCode);

    formData.append('country', country);

    formData.append('contract', contract);
    formData.append('signedAt', signedAt);
    formData.append('license', license);
    formData.append('lastBackup', lastBackup);

    formData.append('customerPlans', JSON.stringify(customerPlans));
    formData.append('additionalBranches', JSON.stringify(additionalBranches || []));
    formData.append('accessQuantity', accessQuantity);

    formData.append('consultant', consultant);
    formData.append('consultantCommission', consultantCommission);

    formData.append('partner', partner);
    formData.append('partnerCommission', partnerCommission);

    formData.append('representative', representative);
    formData.append('representativeCommission', representativeCommission);

    formData.append('counter', counter);
    formData.append('counterCommission', counterCommission);

    formData.append('unit', unit);
    formData.append('unitCommission', unitCommission);

    formData.append('regime', RegimeTypeIdEnum[regime]);
    formData.append(
      'fiscalEnvironment',
      FiscalEnvironmentIdEnum[fiscalEnvironment]
    );
    formData.append('csc', csc);
    formData.append('cscId', cscId);


    formData.append('digitalCertificate', digitalCertificate);

    if (createdAt) {
      formData.append('createdAt', new Date(createdAt).toISOString());
    }

    if (updatedAt) {
      formData.append('updatedAt', new Date(updatedAt).toISOString());
    }

    formData.append('mainActivity', mainActivity);

    formData.append('contractComment', contractComment);
    formData.append('contractDate', contractDate);
    formData.append('licenseComment', licenseComment);
    formData.append('lastBackupComment', lastBackupComment);
    formData.append('digitalCertificateComment', digitalCertificateComment);

    formData.append('licenseDate', licenseDate);
    formData.append('lastBackupDate', lastBackupDate);
    formData.append('digitalCertificateDate', digitalCertificateDate);

    return formData;
  }
}
